import React from 'react';
import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { DateRange, DatePick, InputRage, InputItem, CheckSwitchButton, RefBoxForReportForms } from '../../../../../index';
import { Modal } from 'antd-mobile';
import RefPageView from '../../view/RefPageView';
import './style.less';

@observer
class SearchPlan extends React.Component {

  state = {
    refParams: {},
    visible: false,
    fullScreen: false // 参照 是否全屏
  }

  handleChange = (code, value) => {
    this.props.items.find(it => it.code === code).setValue(value);
    //console.log('items:', this.props)
  }

  handleRefBoxClick = (refInfo) => {
    const {
      id,
      refDataSource,
      dtoName,
      multiSelect,
      type,
      value,
      valueType,
      mode
    } = refInfo;

    const param = {
      ...JSON.parse(JSON.stringify(refInfo)),
      searchItemCtrlId: id,
      refDataSource,
      refObject: dtoName,
      selecteds: mode === 'single' ? (value && value.value ? [{
        $text: value.text,
        [valueType]: value.value
      }] : []) : mode === 'range' ? (value.filter(it => it.value).length > 0 ? [{
        $text: (value[0]).text,
        [valueType]: (value[0]).value
      }] : []) : value.map(it => ({
        $text: it.text,
        [valueType]: it.value
      })),
      multiSelect: mode == 'multi' || type == 'multireftextbox' || multiSelect
    };
    // this.context.pushForResult('/reference', param);
    this.setState({
      visible: true,
      refParams: param
    })
  }

  renderFilter = ({
    id,
    code,
    name,
    type,
    mode,
    component,
    value,
    visible,
    disabled,
    valueType,
    options
  }) => {
    let element;
    let opts = {
      id,
      visible,
      disabled,
      code,
      name,
      type,
      mode,
      valueType,
      name,
      ...options
    };
    let showLabel = true;
    switch (component) {

      case 'dateRange':
        //showLabel = false;
        element = (<DateRange onChange={v => this.handleChange(code, v)} value={value.map(it => it.value)} {...opts} />);
        break;
      case 'datePick':
        //showLabel = false;
        element = (<DatePick onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'inputItem':
        element = (<InputItem onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'inputRange':
        element = (<InputRage onChange={v => this.handleChange(code, v)} value={value.map(it => it.value)} {...opts} />);
        break;
      case 'buttonGroup':
        showLabel = false;
        element = (<CheckSwitchButton onChange={v => this.handleChange(code, v)} value={value && value.value} {...opts} />);
        break;
      case 'refBox':
        element = <RefBoxForReportForms onClick={this.handleRefBoxClick} value={value} {...opts} />;
        break;
      default:
        element = null;
        break;
    }
    return (<div key={code} className='filter'>
      {showLabel ? <span htmlFor={code}>{name}</span> : null}
      {element}
    </div>);
  }

  callBack = (...result) => {
    this.closeRefPage();
    this.props.callBack && this.props.callBack(...result);
  }

  closeRefPage = () => {
    this.setState({
      visible: false,
      fullScreen: false
    })
  }

  searchBarFocus = () => {
    this.setState({
      fullScreen: true
    })
  }

  render() {
    // timetextbox 移动端不支持
    let {visible, refParams, fullScreen} = this.state;
    return (
      <React.Fragment>

        <div className={`searchPlan ${visible ? 'relative': ''}`}>
          {this.props.items.map(it => (this.renderFilter(it)))}
        </div>

        <Modal
          popup
          visible={visible} animationType="slide-up"
          className={`ref-page ${fullScreen ? 'fullScreen' : ''}`}
          onClose={this.closeRefPage}
          wrapClassName='refWrapClassName' >
            <RefPageView fullScreen={fullScreen} refParams={refParams} callBack={this.callBack} close={this.closeRefPage} searchBarFocus={this.searchBarFocus} />
        </Modal>
      </React.Fragment>
    )
  }
}

SearchPlan.contextTypes = {
  pop: PropTypes.func,
  push: PropTypes.func,
  pushForResult: PropTypes.func,
  pageParam: PropTypes.func,
  popAndReturn: PropTypes.func,
  replace: PropTypes.func
}

export default SearchPlan;
